

















import { Component, Vue, Prop } from 'vue-property-decorator'
import OzBox, { OzBoxColors } from 'library/v4/components/OzBox.vue'
import OzDivider, { OzDividerColorScheme } from 'library/v4/components/OzDivider.vue'
import DashboardSettingsBillingCollectionItem from 'vuecomponents/DashboardSettingsBillingCollectionItem.vue'

@Component({ components: { DashboardSettingsBillingCollectionItem, OzBox, OzDivider } })
export default class DashboardSettingsBillingCollectionItems extends Vue {
  /**
   * An array of texts to be rendered inside the box as items.
   */
  @Prop() items!: string[]

  OzBoxColors = OzBoxColors
  OzDividerColorScheme = OzDividerColorScheme
}
